export default __webpack_public_path__ + "static/cristina-53e0a21e0159e0d80e275cb9f304e30e.png";